export default {
	APP: {
		SESSION: 'v2/session',
		LOGIN_WITH_ADMIN: 'v2/session/disasemble',
		LOGGER: 'v2/fe-logger',
		REFUSE_RECORD: 'v2/refuse-record'
	},

	NEWS: {
		LIST: 'v2/news'
	},

	DISCOUNTS: {
		LIST: 'v2/discounts'
	},
	LANG_RULES: {
		SINGLE: 'v2/lang-rules/{lang}'
	},

	OFFERS: {
		LIST: 'v2/offers',
		ACTIVE: 'v2/offers/active',
		OFFER_DOMAINS: {
			DOWNLOAD: 'v2/'
		}
	},

	STATISTICS: {
		GENERAL: 'v2/analytics/general',
		ANALYTICS: 'v2/analytics/analytics',
		SYSTEM_ANALYTICS: 'v2/analytics/system-analytics',
		CONVERSIONS: 'v2/analytics/conversions',
		UNACCEPTABLE_CONVERSIONS: 'v2/unacceptable-conversions',
		CONVERSIONS_COUNT: 'v2/analytics/conversions-count',
		CHAINS_FILTERS: {
			OFFERS: 'v2/analytics/chains/lists/offers'
		},
		CHAINS: {
			COUNTRIES: 'v2/chains/targets',
			OFFERS: 'v2/chains/offers',
			LIST: 'v2/chains/list'

		},
		LISTS: 'v2/analytics/lists',
		GET_LAST_CONVERSION: 'v2/analytics/get-last-conversion',
		FILTERS: {
			OFFERS: 'v2/analytics/lists/offers',
			LANDINGS: 'v2/analytics/lists/landings',
			TRANSITS: 'v2/analytics/lists/transits',
			CAMPAIGNS: 'v2/analytics/lists/campaigns',
			SPACES: 'v2/analytics/lists/spaces',
			TRAFFIC_SOURCES: 'v2/analytics/lists/traffic_sources',
			SID1: 'v2/analytics/lists/sids1',
			SID2: 'v2/analytics/lists/sids2',
			SID3: 'v2/analytics/lists/sids3',
			SID4: 'v2/analytics/lists/sids4',
			SID5: 'v2/analytics/lists/sids5',
			TRAFFIC_TYPES: 'v2/analytics/lists/traffic_types',
			SPLIT_SESSIONS: 'v2/analytics/lists/split_sessions',
			SALE_MODELS: 'v2/analytics/lists/sale_models',
			AFFILIATES: 'v2/analytics/lists/affiliates'
		}
	},

	MARKET: {
		MAIN: 'v2/bonus-market',
		SAVEUP_FOR: 'v2/bonus-market/saveup',
		ORDER: 'v2/bonus-market/{id}'
	},

	BM_ACCOUNTS: {
		MAIN: 'v2/bm-accounts',
		ORDER: 'v2/bm-accounts/{id}/order'
	},

	PROFILE: {
		MAIN: 'v2/profile',
		BALANCES: 'v2/profile/balances',
		MANAGER: 'v2/profile/manager',
		PAYOUT_SETTINGS: 'v2/profile/payout-settings',
		PAYOUT_SYSTEMS: 'v2/profile/payout-systems',
		AVATAR: 'v2/profile/avatar',
		PASSWORD: 'v2/profile/password',
		TWO_FACTOR_AUTHENTICATION_INIT: 'v2/session/two-factor-authentication',
		TWO_FACTOR_AUTHENTICATION_ACTIVATE: 'v2/session/two-factor-authentication/activate',
		TWO_FACTOR_AUTHENTICATION_DEACTIVATE: 'v2/session/two-factor-authentication/deactivate',
		NOTIFICATIONS: 'v2/profile/notifications',
		GLOBAL_POSTBACK: 'v2/profile/global-postback',
		RESEND_POSTBACK: 'v2/profile/resend-postbacks',
		SAVED_FILTERS: 'v2/profile/saved-filters',
		PREFERRED_GIFT: 'v2/profile/preferred-gift',
		CONTEST_STANDINGS: 'v2/profile/contest-standings',
		APP_CONFIG: 'v2/profile/app-config',
		VISIT_DASHBOARD: 'v2/session/visit-dashboard',
		SURVEY: 'v2/profile/survey'
	},

	SPACES: {
		LIST: 'v2/spaces'
	},

	RANKS: {
		INFO: 'v2/rank',
		GOODS_LIST: 'v2/rank/goods',
		NOTIFIED: 'v2/rank/notified'
	},

	TICKETS: {
		ALL: 'v2/threads',
		PROMOCODE: 'v2/threads/promocode'
	},

	LISTS: {
		ALL: 'v2/lists',
		POSTBACK_LOG: 'v2/lists/postback-log',
		ALL_POSTBACK_LOG: 'v2/lists/postback-log/all',
		LANDING_SNIPPETS: 'v2/lists/landings-snippets',
		CAMPAIGN_DOMAINS: 'v2/lists/campaign-domains',
		ADV_SYSTEMS: 'v2/lists/adv-systems'
	},

	FINANCES: {
		HISTORY: 'v2/finances/transactions',
		CURRENCY_CONVERSIONS: 'v2/finances/currency-conversions',
		PAYOUTS: 'v2/finances/payouts',
		AFFILIATE_PAYOUTS: 'v2/finances/affiliate-payouts',
		POINTS: 'v2/finances/points',
		RATES: 'v2/finances/current-rate'
	},

	STREAMS: {
		LIST: 'v2/campaigns',
		CLONE: 'v2/campaigns/clone',
		TEST_CONVERSION: 'v2/campaigns//test-conversion'
	},

	STREAM: {
		SPLIT_SESSIONS: 'v2/campaigns/{streamId}/split-sessions',
		POSTBACK_LOGS: 'v2/campaigns/{streamId}/postback-log',
		ROOT: 'v2/campaigns'
	},

	POLLS: {
		BASE: 'v2/polls'
	},

	POPUPS: {
		BASE: 'v2/popups/on-start-popups',
		CLOSE_ON_START: 'v2/popups/close-on-start-popup'
	},

	LOOKUPS: {
		OFFERS: '/v2/lookups/offers',
		CITIES: '/v2/lookups/cities',
		COUNTRIES: '/v2/lookups/locations',
		STREAMS: '/v2/lookups/campaigns',
		POSTBACK_CONVERSIONS: '/v2/lookups/postback-conversions',
		LANDINGS: '/v2/lookups/landings',
		TRANSITS: '/v2/lookups/transits',
		GOOD_CATEGORIES: '/v2/lookups/good-categories',
		STATUS_CHANGED_AT: '/v2/lookups/status-changed-at',
		TARGETING_LOCATIONS: 'v2/lookups/targeting-locations'
	},
	GOOD_CATEGORIES: '/v2/good-categories',
	SMART_NOTIFICATIONS: {
		POP: 'v2/smart-notifications'
	},
	MASTER_ACCOUNT: {
		BASE: 'v2/master-account',
		INDIVIDUAL_TERMS: 'v2/master-account/{offerId}/individual-terms/{affiliateId}'
	},
	BANNERS: {
		BY_CAMPAIGN: '/v2/banners'
	},
	CUSTOM_POPUPS: {
		BASE: '/v2/custom-popups',
		SAVE_VIEWED: '/v2/custom-popups/save-viewed'
	}
};



// WEBPACK FOOTER //
// ./frontend/cabinets/config/endpoints.js